import React from 'react';
import CongestionSummary from './CongestionSummary';
import { useTranslation } from 'react-i18next';

const checkFalsyValue = value => {
    return value ? value : 0;
};

const SelectedCongestionSummary = ({ selectedCongestionInfo }) => {
    const { t } = useTranslation();
    return (
        <div className={'d-grid'} style={{ gridTemplateColumns: 'repeat(4,1fr)' }}>
            <CongestionSummary
                count={checkFalsyValue(selectedCongestionInfo.entryCount)}
                totalCount={0}
                label={t('CongestionStatus;Total count of entries')}
            />
            <CongestionSummary
                count={checkFalsyValue(selectedCongestionInfo.uniqueCount)}
                totalCount={0}
                label={t('CongestionStatus;Unique count of entries')}
            />
            <CongestionSummary
                time={true}
                sec={checkFalsyValue(selectedCongestionInfo.avgStayEntryTime)}
                label={t('CongestionStatus;Average length of stay of total entries')}
            />
            <CongestionSummary
                time={true}
                sec={checkFalsyValue(selectedCongestionInfo.avgStayUniqueTime)}
                label={t('CongestionStatus;Average length of stay of unique entries')}
            />
        </div>
    );
};

export default SelectedCongestionSummary;
